import { combineReducers } from 'redux';

import athleteReportCardDataReducer from './athleteReportCardDataReducer';
import athleteReportCardUiReducer from './athleteReportCardUiReducer';

export default combineReducers({
  data: athleteReportCardDataReducer,
  ui: athleteReportCardUiReducer,
});
